/** Inbox cards cap at 600px; the in-app desktop preview should fill the pane. */
const EMAIL_CARD_MAX_WIDTH = /max-width:\s*600px/i;

export function withFullWidthEmailPreview(html: string): string {
  if (!EMAIL_CARD_MAX_WIDTH.test(html)) return html;
  return html
    .replace(/max-width:\s*600px/gi, "max-width:100%")
    .replace(/\bwidth="600"/g, 'width="100%"');
}
